import {
    FETCH_USER_CAPABLE_FETCHING,
    FETCH_USER_CAPABLE_SUCCESS,
    FETCH_USER_CAPABLE_FAIL
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    userCapable: null,
    userCapableFetching: false,
    userCapableFetchFail: false
};

const userCapableFetching = (state) => {
    return {
        ...state,
        userCapableFetching: true,
        userCapableFetchFail: false
    };
};

const userCapableFetchFinished = (isSuccess) => (state, action) => {
    return {
        ...state,
        userCapable: {
            ...state.userCapable,
            [action.capableName]: isSuccess ? action.userCapable : null
        },
        userCapableFetching: false,
        userCapableFetchFail: !isSuccess
    };
};

export const isUserCapableFetching = (state) => {
    return state.userCapable.userCapableFetching;
};

export const isUserCapableFetchFail = (state) => {
    return state.userCapable.userCapableFetchFail;
};

export const getUserCapable = (state, capableName) => {
    return state.userCapable.userCapable ? state.userCapable.userCapable[capableName] : null;
};

const handlers = {
    [FETCH_USER_CAPABLE_FETCHING]: userCapableFetching,
    [FETCH_USER_CAPABLE_SUCCESS]: userCapableFetchFinished(true),
    [FETCH_USER_CAPABLE_FAIL]: userCapableFetchFinished(false)
};

export default function userCapable(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
